<template>
	<div id="default">
		<router-view class="container view"></router-view>
	</div>
</template>

<script>
import FluxBotWalletAdapter from "@/api/fluxbot/wallet_adapter";
import {mapStores} from "pinia";
import {useWalletStore} from "@/pinia";

export default {
	name: "DefaultLayout",
	computed: {
		...mapStores(useWalletStore),
	},
	methods: {
		getFluxBotAuth() {
			const fluxAuth = localStorage.getItem("fluxbot:auth");
			if (fluxAuth) {
				const adapter = new FluxBotWalletAdapter()
				adapter.connect()
				if (adapter.connected) {
					this.walletStore.setWallet(adapter)
				}
			}
		},
	},
	beforeMount() {
		this.getFluxBotAuth() //Only attempt, no issues if we dont detect
	},
}
</script>

<style scoped>
.view {
	min-height: 75vh;
}
</style>